import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'
import { PigmentTick } from './PigmentTick'

interface TitleRowProps {
  /** The screen's `title`: the parish name on Beranda, "Keluarga" on the list, a person's name. */
  judul: string
  /** `label` muted beneath the title: "Lingkungan St. Maria · Paroki Katedral Salib Suci Agats". */
  subjudul?: string | undefined
  /** The one red action of the screen (or a text link where the screen has none). */
  aksi?: ReactNode
  className?: string
}

/**
 * The title row that opens every route (DNA screen grammar): pigment-tick, Newsreader 28
 * title, subtitle in `label`, and the single primary button of the screen on the right.
 * Under 640 px the button drops beneath the title at full width so a long parish name
 * keeps its two lines.
 */
export function TitleRow({ judul, subjudul, aksi, className }: TitleRowProps) {
  return (
    <div
      className={cn(
        'flex flex-col gap-4 py-6 sm:flex-row sm:items-start sm:justify-between sm:gap-6',
        className,
      )}
    >
      <div className="min-w-0">
        <h1 tabIndex={-1} className="flex items-baseline gap-1 font-display text-title text-text">
          <PigmentTick />
          <span>{judul}</span>
        </h1>
        {subjudul !== undefined ? (
          <p className="mt-1 text-label font-medium text-muted">{subjudul}</p>
        ) : null}
      </div>
      {aksi !== undefined ? (
        <div className="flex shrink-0 *:w-full sm:pt-0.5 sm:*:w-auto">{aksi}</div>
      ) : null}
    </div>
  )
}
